export enum RequestOTPSelectionEnum {
  Phone,
  Email,
}
